<div class="iri_lock">
    <div class="icon_lock">
        <img src="../../../../assets/icons/IconLock.svg" />
    </div>
    <div class="icon_premium_title">
        <img src="../../../../assets/icons/IconPremium.svg" />
        <span>Shariah Compliance Report</span>
    </div>
    <p>An extensive business & Financial screening of the company which specifies why a stock is halal or haram!</p>



<button class="btn shadow-none rounded-3 text-white py-2 px-4 gradient-btn" *ngIf="userRole === 'FREEMIUM' || userRole === 'ANONYMOUS'"  (click)="accessControlService.accessDenied()">
            <!-- Upgrade & Unlock! -->
            <img src="../../../../assets/icons/lock-white.svg" width="16" height="16" alt="lock image" class="img-fluid">
            <span>Unlock</span>
         </button>


    <a (click)="viewSample()"  class="link_view_sample">View Sample Shariah Compliance Report</a>
</div>
